import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[input-host]',
    standalone: false
})
export class BotatoChatInputDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
